'use client';

import { c as _c } from "react/compiler-runtime";
import { Card } from '@morpho-org/ui-v6/server';
import { memo, type ReactNode } from 'react';
import type { VaultApyCardData } from './VaultApyCard.mapper';
import RateCard from './RateCard';
export interface ApyCardClientProps {
  vault: VaultApyCardData;
  chartApySlot: ReactNode;
}

/**
 * Apy Card component to display the chart and all the rates for the vault
 * Layout is responsive via CSS (`lg:` variants), not JS breakpoints
 */
const ApyCardClient = t0 => {
  const $ = _c(7);
  const {
    vault,
    chartApySlot
  } = t0;
  let t1;
  if ($[0] !== chartApySlot) {
    t1 = <Card className="py-lg px-md lg:contents" withBorder={true}>{chartApySlot}</Card>;
    $[0] = chartApySlot;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== vault) {
    t2 = <Card className="py-lg px-md flex-col lg:contents" withBorder={true}><RateCard vault={vault} /></Card>;
    $[2] = vault;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div data-testid="vault-v1-apy-card" className="gap-sm lg:gap-lg lg:border-border lg:bg-card lg:p-lg flex w-full flex-col lg:flex-row lg:rounded-[20px] lg:border-[0.5px] lg:shadow-md dark:lg:shadow-none">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default memo(ApyCardClient);